import { Linkify as format } from '@99designs/ninedown';
import * as React from 'react';
interface Props {
    urls: string[];
}

export const linkify = (links: string[]) => {
    return links && links.length > 0 ? <Linkify urls={links} /> : '';
};

const Linkify = (props: Props) => {
    const { urls } = props;

    const createMarkUp = (input: string) => {
        return { __html: format(input, window.location.hostname) };
    };

    return (
        <div>
            {urls.map((url: string, id: number) => {
                return <div key={id} dangerouslySetInnerHTML={createMarkUp(url)} />;
            })}
        </div>
    );
};

export default Linkify;
